var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.335,
    height: 17.505,
    viewBox: "0 0 63.335 17.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4365",
    "data-name": "\\uADF8\\uB8F9 4365",
    transform: "translate(-197.638 -362.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4362",
    "data-name": "\\uADF8\\uB8F9 4362",
    transform: "translate(197.638 362.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_233",
    "data-name": "\\uD328\\uC2A4 233",
    d: "M199.119,363.581l-1.481,5.509V362.1h6.99Z",
    transform: "translate(-197.638 -362.1)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_234",
    "data-name": "\\uD328\\uC2A4 234",
    d: "M278.948,363.581l-5.509-1.481h6.99v6.99Z",
    transform: "translate(-262.924 -362.1)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_235",
    "data-name": "\\uD328\\uC2A4 235",
    d: "M278.948,443.41l1.481-5.509v6.99h-6.99Z",
    transform: "translate(-262.924 -427.386)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_236",
    "data-name": "\\uD328\\uC2A4 236",
    d: "M199.119,443.41l5.509,1.481h-6.99V437.9Z",
    transform: "translate(-197.638 -427.386)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_237",
    "data-name": "\\uD328\\uC2A4 237",
    d: "M218.866,383.462a1.188,1.188,0,1,1-1.188-1.188A1.188,1.188,0,0,1,218.866,383.462Z",
    transform: "translate(-213.874 -379.476)",
    fill: "#434343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4363",
    "data-name": "\\uADF8\\uB8F9 4363",
    transform: "translate(221.098 362.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_238",
    "data-name": "\\uD328\\uC2A4 238",
    d: "M428.954,377.458h4.521v1.627h-6.4V367.972h1.877Z",
    transform: "translate(-418.711 -367.972)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_239",
    "data-name": "\\uD328\\uC2A4 239",
    d: "M543.965,379.085V367.972h3.682a3.171,3.171,0,0,1,2.858,1.482,3.783,3.783,0,0,1,.583,2.077v3.98a3.576,3.576,0,0,1-1.024,2.629,3.291,3.291,0,0,1-2.417.944Zm1.876-9.486v7.859h1.806a1.417,1.417,0,0,0,1.379-.988,2.5,2.5,0,0,0,.185-.959v-3.98a1.963,1.963,0,0,0-.668-1.627,1.436,1.436,0,0,0-.9-.305Z",
    transform: "translate(-519.385 -367.972)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_240",
    "data-name": "\\uD328\\uC2A4 240",
    d: "M367.421,465.49v.918H369.1v.478h-2.338v-3.267h2.288v.478h-1.631v.918h1.423v.474Z",
    transform: "translate(-366.764 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_241",
    "data-name": "\\uD328\\uC2A4 241",
    d: "M391.459,463.619h.657v3.267h-.99l-.731-2.191-.065-.4v2.593h-.657v-3.267h.99l.731,2.187.065.41Z",
    transform: "translate(-386.495 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_242",
    "data-name": "\\uD328\\uC2A4 242",
    d: "M412.545,464.1v-.478h2.442v.478h-.89v2.789h-.661V464.1Z",
    transform: "translate(-406.195 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_243",
    "data-name": "\\uD328\\uC2A4 243",
    d: "M436.543,465.49v.918h1.681v.478h-2.338v-3.267h2.288v.478h-1.631v.918h1.422v.474Z",
    transform: "translate(-426.298 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_244",
    "data-name": "\\uD328\\uC2A4 244",
    d: "M459.452,466.886H458.8v-3.267h1.288a1.2,1.2,0,0,1,1,.414.9.9,0,0,1-.159,1.294,1.083,1.083,0,0,1-.269.154l.746,1.405h-.756l-.637-1.3h-.557Zm0-2.789v1.008h.632a.483.483,0,0,0,.472-.269.515.515,0,0,0,.06-.239.464.464,0,0,0-.229-.423.6.6,0,0,0-.3-.077Z",
    transform: "translate(-446.029 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_245",
    "data-name": "\\uD328\\uC2A4 245",
    d: "M481.6,464.1v-.478h2.442v.478h-.89v2.789h-.662V464.1Z",
    transform: "translate(-465.668 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_246",
    "data-name": "\\uD328\\uC2A4 246",
    d: "M501.893,463.619h.965l.865,3.267h-.711l-.144-.607h-.985l-.149.607h-.706Zm.478.491-.02.222L502,465.8h.756l-.353-1.469Z",
    transform: "translate(-482.404 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_247",
    "data-name": "\\uD328\\uC2A4 247",
    d: "M525.659,463.619h.657v3.267h-.657Z",
    transform: "translate(-503.618 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_248",
    "data-name": "\\uD328\\uC2A4 248",
    d: "M538.773,463.619h.657v3.267h-.99l-.731-2.191-.065-.4v2.593h-.657v-3.267h.99l.731,2.187.065.41Z",
    transform: "translate(-513.375 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_249",
    "data-name": "\\uD328\\uC2A4 249",
    d: "M561.809,466.886h-.657v-3.267h1.064l.542,1.64.532-1.64h1.065v3.267H563.7V464.14q-.01.073-.04.209c-.02.094-.033.164-.04.209l-.537,1.537-.657,0-.537-1.542-.08-.414Z",
    transform: "translate(-534.188 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_250",
    "data-name": "\\uD328\\uC2A4 250",
    d: "M591.5,465.49v.918h1.681v.478h-2.338v-3.267h2.288v.478H591.5v.918h1.422v.474Z",
    transform: "translate(-559.757 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_251",
    "data-name": "\\uD328\\uC2A4 251",
    d: "M615.532,463.619h.657v3.267h-.99l-.731-2.191-.064-.4v2.593h-.657v-3.267h.99l.731,2.187.064.41Z",
    transform: "translate(-579.487 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_252",
    "data-name": "\\uD328\\uC2A4 252",
    d: "M636.62,464.1v-.478h2.442v.478h-.89v2.789h-.662V464.1Z",
    transform: "translate(-599.188 -450.352)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_253",
    "data-name": "\\uD328\\uC2A4 253",
    d: "M487.757,379.085l-2.474-11.113h-2.758l-2.474,11.113h2.011l1.828-9.1,1.821,9.039h0c.005,0,0,0,0,0l.012.061Z",
    transform: "translate(-464.338 -367.972)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_282",
    "data-name": "\\uD0C0\\uC6D0 282",
    cx: 0.871,
    cy: 0.871,
    r: 0.871,
    transform: "translate(18.696 6.901)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1949",
    "data-name": "\\uC0AC\\uAC01\\uD615 1949",
    width: 6.682,
    height: 1.627,
    transform: "translate(32.926 0)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1950",
    "data-name": "\\uC0AC\\uAC01\\uD615 1950",
    width: 6.682,
    height: 1.627,
    transform: "translate(32.926 9.486)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1951",
    "data-name": "\\uC0AC\\uAC01\\uD615 1951",
    width: 6.682,
    height: 1.612,
    transform: "translate(32.926 4.75)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_254",
    "data-name": "\\uD328\\uC2A4 254",
    d: "M374.622,375.235a2.894,2.894,0,0,0-1.507-2.077q.1-.073.213-.174a2.764,2.764,0,0,0,.924-2.135,2.878,2.878,0,0,0-.455-1.583,2.847,2.847,0,0,0-2.587-1.293h-3.682v11.113h3.682a3.575,3.575,0,0,0,2.46-.843,3.04,3.04,0,0,0,1.024-2.353A3.16,3.16,0,0,0,374.622,375.235Zm-2.019,1.322a1.408,1.408,0,0,1-1.393.9H369.4V369.6h1.806a1,1,0,0,1,.583.189,1.383,1.383,0,0,1,.54,1.22,1.874,1.874,0,0,1-.1.61,1.036,1.036,0,0,1-1.024.784h-.133v1.627h.133a1.5,1.5,0,0,1,.91.291,1.692,1.692,0,0,1,.654,1.438A1.912,1.912,0,0,1,372.6,376.557Z",
    transform: "translate(-367.422 -367.972)",
    fill: "#434343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamLogo);
export default __webpack_public_path__ + "static/media/ham_logo.480cc303fbb60f9c09d5100e2220e19a.svg";
export { ForwardRef as ReactComponent };